import { styled } from '@mui/material';

export const Svg = styled('svg')(({ theme }) => ({
  display: 'block',
  width: '100%',
  height: '100%',
  margin: '0em auto',
}));
